import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ACCEPTORREJECTREQUEST, BASE_URL, CANCELREQUEST, WARDPENDINGREQUEST, UPDATE_WARD_REQUEST } from 'src/app/endpoints';

@Injectable({
  providedIn: 'root'
})
export class RequestsService {

  constructor(private http:HttpClient) { }

   wardLogpendingRequests(data: any) {  
    return this.http.post<any>(BASE_URL + WARDPENDINGREQUEST, data)
   }

   acceptrejectRequest(data: any) {
    return this.http.post(BASE_URL + ACCEPTORREJECTREQUEST, data);
  }
    cancelRequest(id: string) {
    return this.http.post(BASE_URL + CANCELREQUEST, { _id: id});
  }

  updateWardIdInRequest(data: any) {
    return this.http.post(BASE_URL + UPDATE_WARD_REQUEST, data);
  }
}
